
































































import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { CardNews } from '@/contracts/Cards'
import CardDefault from '@/components/Cards/CardDefault.vue'
import Loader from '@/plugins/loader/Load.vue'

export default defineComponent({
  name: 'BlockCardNewsList',
  components: {
    CardDefault,
    Loader,
  },
  props: {
    list: {
      type: Array as PropType<CardNews[]>,
      default: () => [],
    },
    countNews: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 0,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    textButton: {
      type: String,
      default: '',
    },
    loadNews: {
      type: Boolean,
      default: false,
    },
    loadError: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loadErrorMessage:
        'Что-то пошло не так при загрузке новостей. Попробуйте обновить страницу или зайти позже',
      localCount: 6,
      oldCount: 6,
      showButton: this.list.length <= this.totalCount,
      styleOne: false,
      styleTwo: false,
      styleThree: false,
    }
  },
  computed: {
    localCardData(): any {
      this.renderBlocks(this.list, this.localCount, this.oldCount)
      return this.list
    },
  },
  methods: {
    addMoreBlocks() {
      this.oldCount = this.localCount
      this.localCount += this.count
      this.showButton = !(this.totalCount - this.localCount <= 0)
      this.$emit('getMore', this.list[this.list.length - 1].id)
      this.renderBlocks(this.list, this.localCount, this.oldCount)
    },
    renderBlocks(array: Array<any>, newCount: number, oldCount: number) {
      const data = array.slice(0, newCount)
      const dataLength: number = data.length
      let delay: number = 1
      data.forEach((item: CardNews, index: number) => {
        const needDelay =
          dataLength -
            oldCount +
            index -
            (dataLength % this.count || this.count) ===
          index
        if (needDelay) {
          item.delay = delay - oldCount
          delay++
        }
        if (dataLength - 1 === index) {
          delay = 0
        }
      })
      this.styleOne = false
      this.styleTwo = false
      if (this.list.length % 3 === 0) {
        this.styleOne = true
      } else if (this.list.length === 1 || this.list.length === 2) {
        this.styleThree = true
      } else {
        this.styleTwo = true
      }
    },
  },
})
